import React from 'react';

import { useConfig } from '@xingternal/hops';
import { HeaderLoggedOut } from '@xingternal/platform-layout-header-logged-out';
import { Footer } from '@xingternal/platform-layout-footer';

import MemberDirectory from '../Components/MemberDirectory/MemberDirectory';

const CustomFrame = ({
  hideLoginButton,
  hideSignupButton,
  homeLink,
  loginLink,
  signupLink,
  children,
}) => {
  const { externalLoginUrl } = useConfig();
  loginLink = loginLink || externalLoginUrl;

  return (
    <React.Fragment>
      <HeaderLoggedOut
        {...{
          hideLoginButton,
          hideSignupButton,
          homeLink,
          loginLink,
          signupLink,
        }}
      />
      {children}
      <Footer {...{ homeLink }} />
      <MemberDirectory />
    </React.Fragment>
  );
};

export default CustomFrame;
